<script>
	import EchoClientCore from './core'

	export default {
		name: 'echo-client',
		extends: EchoClientCore,
		mixins: [
			//ChannelsMixin,
		],
		data() {
			return {
			}
		},
		methods: {
			stopListeningAll() {
				this.logMessage('Stopping to listen to everything');

				let channel = this.channel('poll');

				channel.stopListening('NewActivePoll');
				channel.stopListening('AcceptAnswersUpdated');
				channel.stopListening('ReachedEnd');
				channel.stopListening('StatsUpdated');
				channel.stopListening('VisualisationUpdated');
				channel.stopListening('VotesUpdated');
			},
			listenNewActivePoll(callback) {
				this.logMessage(`Listening to poll.NewActivePoll`);

				this.channel('poll').listen('NewActivePoll', (e) => {
					callback(e);
				});
			},
			listenAcceptAnswersUpdated(callback) {
				this.logMessage(`Listening to poll.AcceptAnswersUpdated`);

				this.channel('poll').listen('AcceptAnswersUpdated', (e) => {
					callback(e);
				});
			},
			listenReachedEnd(callback) {
				this.logMessage(`Listening to poll.ReachedEnd`);

				this.channel('poll').listen('ReachedEnd', (e) => {
					callback(e);
				});
			},
			listenStatsUpdated(callback) {
				this.logMessage(`Listening to poll.StatsUpdated`);

				this.channel('poll').listen('StatsUpdated', (e) => {
					callback(e);
				});
			},
			listenVisualisationUpdated(callback) {
				this.logMessage(`Listening to poll.VisualisationUpdated`);

				this.channel('poll').listen('VisualisationUpdated', (e) => {
					console.log('ON VISUALISATION UPDATED', e);
					callback(e);
				});
			},
			listenVotesUpdated(callback) {
				this.logMessage(`Listening to poll.VotesUpdated`);

				this.channel('poll').listen('VotesUpdated', (e) => {
					callback(e);
				});
			}
		}
	}
</script>
